import { DomUtils } from './utils';

class Video {
    constructor() {
        this.DOM = {
            body: document.body,
            videoPlayers: document.querySelectorAll('.video-player'),
            videoPlayersInline: document.querySelectorAll('.inline-player'),
            videoPlayerButtons: document.querySelectorAll('.video-play-button')
        };

        if (!this.DOM.videoPlayers) {
            return;
        }

        const viewportWidth = DomUtils.getViewportWidth();
        this.isMobile = viewportWidth < 800;

        this.setVideoSource();
        this.setVideosInline();
        this.triggerVideosInView();
        this.triggerVideoOnClick();
        this.setVideosYoutube();
    }

    setVideosInline() {
        this.DOM.videoPlayersInline.forEach((playerBlock) => {
            const player = playerBlock.querySelector('.video-player');
            playerBlock.addEventListener('click', () => {
                if (!player.hasAttribute('controls')) {
                    playerBlock.classList.add('playing');
                    player.setAttribute('controls', '');

                    setTimeout(() => {
                        player.play();
                    }, 200);
                }
            });
        });
    }

    setVideoSource() {
        this.DOM.videoPlayers.forEach((player) => {
            const videoSrcDesktop = player.getAttribute('data-src-desktop');
            const videoSrcMobile = player.getAttribute('data-src-mobile');
            const videoDelay = player.getAttribute('data-delay');
            const hasVideoDelay = parseInt(videoDelay) > 50;

            const hasAutoplay = player.getAttribute('autoplay') !== null;
            if (hasAutoplay) {
                player.removeAttribute('autoplay');

                if (!hasVideoDelay) {
                    player.classList.add('trigger-video-in-view');
                }
            }

            let setSourceDelay = 0;
            const isLazy = player.classList.contains('lazy');
            if (isLazy) {
                setSourceDelay = 3000;
            }

            let videoSrc = videoSrcDesktop;

            if (this.isMobile) {
                videoSrc = videoSrcMobile;
            }

            // Create source element for video
            setTimeout(() => {
                // console.log('video, lazy :', isLazy, player);
                let sourceElement = document.createElement('source');

                if (hasVideoDelay) {
                    setTimeout(() => {
                        sourceElement.src = videoSrc;
                        sourceElement.type = 'video/mp4';
                        player.appendChild(sourceElement);
                        player.play();
                        console.log('player hasVideoDelay; play');
                    }, videoDelay);
                } else {
                    sourceElement.src = videoSrc;
                    sourceElement.type = 'video/mp4';
                    player.appendChild(sourceElement);
                }
            }, setSourceDelay);
        });
    }

    triggerVideosInView() {
        ScrollTrigger.batch('.trigger-video-in-view', {
            // markers: true,
            onEnter: (elements) => {
                elements.forEach((element) => {
                    element.play();
                });
            },
            onLeave: (elements) => {
                elements.forEach((element) => {
                    element.pause();
                });
            },
            onEnterBack: (elements) => {
                elements.forEach((element) => {
                    element.play();
                });
            },
            onLeaveBack: (elements) => {
                elements.forEach((element) => {
                    element.pause();
                });
            },
            interval: 0.1,
            start: 'top bottom',
            // start: 'top 80%',
            end: 'bottom top'
            // end: 'bottom 20%'
        });
    }

    triggerVideoOnClick() {
        this.DOM.videoPlayers.forEach((player) => {
            player.addEventListener('click', () => {
                const videoWrapper = player.parentElement;
                const hasControls = player.hasAttribute('controls');
                if (hasControls) {
                    videoWrapper.classList.add('playing');
                    player.removeEventListener('click', this);
                } else {
                    videoWrapper.classList.toggle('playing');

                    if (player.paused) {
                        player.play();
                    } else {
                        player.pause();
                    }
                }
            });
        });
    }

    setVideosYoutube() {
        const videosYoutubeWrapperElements = document.querySelectorAll('.video-youtube');
        videosYoutubeWrapperElements.forEach((element) => {
            const clickElement = element.querySelector('.video-wrapper');
            const youtubeIframeElement = element.querySelector('iframe');
            clickElement.addEventListener('click', () => {
                // Play youtube
                const src = youtubeIframeElement.getAttribute('src');
                if (!src.includes('autoplay=1')) {
                    youtubeIframeElement.setAttribute('src', src + (src.includes('?') ? '&' : '?') + 'autoplay=1');
                }
                clickElement.classList.add('playing');
            });
        });
    }
}
new Video();
